module.exports = __webpack_public_path__ + "static/media/left-selected.954a61fe.svg";